// extracted by mini-css-extract-plugin
module.exports = {"Page":"ManagerReflect_Page__2W1bL"};